"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubmittedClaimSchema = exports.submittedClaimSchema_Audit = exports.draftClaimSchema_Audit = exports.submittedClaimSchema = exports.draftClaimSchema = exports.claimSchema = void 0;
/* eslint-disable camelcase */
var Joi = __importStar(require("joi"));
var claim_domain_1 = require("@hobt/claim-domain");
var common_1 = require("../../common");
var borrower_1 = require("./borrower");
var borrower_charges_1 = require("./borrower-charges");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var main_1 = require("./main");
var net_operating_income_rental_income_1 = require("./net-operating-income-rental-income");
var operation_1 = require("./operation");
var partial_payment_1 = require("./partial-payment");
var property_1 = require("./property");
var validation_result_1 = require("./validation-result");
exports.claimSchema = Joi.object({
    approvedLenderFinancialInstitutionCode: Joi.string()
        .min(3)
        .max(3),
    approvedLenderReferenceNumber: Joi.string()
        .min(0)
        .max(20),
    approvedLenderTransitNumber: Joi.string()
        .min(5)
        .max(5),
    attachments: Joi.array().optional(),
    borrowers: Joi.array()
        .items(borrower_1.borrowerSchema)
        .max(10),
    borrowerCharges: Joi.array().items(borrower_charges_1.borrowerCharges),
    claimBusinessID: Joi.string()
        .min(0)
        .max(30),
    claimTypeIndicator: Joi.number()
        .integer()
        .min(claim_domain_1.ClaimTypeIndicator.Main)
        .max(claim_domain_1.ClaimTypeIndicator.Supplementary)
        .options({ convert: false }),
    cmhcLoanAccountNumber: Joi.number()
        .integer()
        .min(10000000)
        .max(99999999)
        .options({ convert: false }),
    exceptionToListing: Joi.boolean(),
    defaultManagement: default_management_1.defaultManagement,
    detail: detail_1.detail,
    indicator: indicator_1.indicatorSchema.optional(),
    lender: lender_1.lender,
    listing: Joi.array()
        .items(listing_1.listingSchema)
        .max(2),
    main: main_1.main,
    netOperatingIncomeRentalIncomes: Joi.array()
        .items(net_operating_income_rental_income_1.netOperatingIncomeRentalIncomeSchema)
        // TODO need to remove to figure out proper logic for this
        .optional(),
    operation: operation_1.operation,
    partialPaymentReceived: Joi.boolean(),
    partialPayments: Joi.array()
        .items(partial_payment_1.partialPaymentSchema)
        // TODO need to remove to figure out proper logic for this
        .optional(),
    property: property_1.property,
    rentalIncomeReceived: Joi.boolean(),
    validationResult: validation_result_1.validationResult,
});
exports.draftClaimSchema = exports.claimSchema.options({ presence: 'optional' });
exports.submittedClaimSchema = exports.claimSchema.options({ presence: 'required' });
exports.draftClaimSchema_Audit = exports.draftClaimSchema.concat(common_1.auditFieldsSchema);
exports.submittedClaimSchema_Audit = exports.submittedClaimSchema.concat(common_1.auditFieldsSchema);
exports.getSubmittedClaimSchema = function () { return Joi.compile(exports.submittedClaimSchema); };
